import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FiMenu, FiX } from "react-icons/fi";
import Logo from "assets/img/logo.png"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    setIsOpen(false); // Close mobile menu if open
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If not on home page, navigate to home and then scroll
      window.location.href = `/#${sectionId}`;
    }
  };
  return (
    <nav className="fixed z-50 w-full bg-white/80 shadow-sm backdrop-blur-md">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - Left */}
          <Link to="/" className="flex items-center">
            <img src={Logo} alt="Logo" className="h-8" />
            <span className="ml-2 text-xl font-bold text-gray-900">
              Riplestack
            </span>
          </Link>

          {/* Desktop Menu - Center */}
          <div className="hidden flex-1 justify-center md:flex">
            <div className="flex items-center space-x-12">
              <button
                onClick={() => scrollToSection("features")}
                className="text-lg text-gray-700 hover:text-purple-600"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection("how-it-works")}
                className="text-lg text-gray-700 hover:text-purple-600"
              >
                How it Works
              </button>
              <button
                onClick={() => scrollToSection("pricing")}
                className="text-lg text-gray-700 hover:text-purple-600"
              >
                Pricing
              </button>
            </div>
          </div>

          {/* Auth Buttons - Right */}
          <div className="hidden items-center space-x-8 md:flex">
            <Link
              to="/auth/sign-in"
              className="text-purple-600 text-lg hover:text-purple-700"
            >
              Sign In
            </Link>
            <Link
              to="/auth/sign-in"
              className="rounded-full text-lg bg-gradient-to-r from-[#7F03E2] to-[#A13BF2] px-6 py-2 text-white transition duration-300 hover:shadow-lg"
            >
              Start 14-day free trial
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="pt-4 md:hidden"
          >
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection("features")}
                className="text-gray-600"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection("how-it-works")}
                className="text-gray-600"
              >
                How it Works
              </button>
              <button
                onClick={() => scrollToSection("pricing")}
                className="text-gray-600"
              >
                Pricing
              </button>
              <Link to="/auth/sign-in" className="text-purple-600 text-center">
                Sign In
              </Link>
              <Link
                to="/main/default"
                className="rounded-full bg-gradient-to-r from-[#7F03E2] to-[#A13BF2] px-6 py-2 text-center text-white"
              >
                Start 14-day free trial
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
